exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2jOn{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_2jOn",
	"root": "_2jOn"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./containers/approche/Approche.css
// module id = 215
// module chunks = 0